import { loadStripe } from '@stripe/stripe-js';
import {
  all,
  call,
  fork,
  put, take,
} from 'redux-saga/effects';
import * as actions from '../actions';
import { shouldUsePaymentService } from '../growthbook';
import history from '../history';
import { apiMethods, apiMethodsConst } from '../services/api';


function* callAndDispatch(method, payload) {
  const response = yield call(apiMethods[method], payload);
  yield put({ type: method, payload: response });
}

function* callAndDispatchPayload(method, payload) {
  yield call(apiMethods[method], payload);
  yield put({ type: method, payload });
}

function* watchGetAllPaymnets() {
  const events = actions.createRequestTypes(actions.GET_ALL_PAYMENTS_ACTION);
  while (true) {
    yield take(actions.GET_ALL_PAYMENTS_ACTION);
    yield put({ type: events.REQUEST });
    try {
      yield* callAndDispatch(apiMethodsConst.GET_ALL_PAYMENTS_REQUEST);
      yield put({ type: events.SUCCESS });
    } catch (error) {
      yield put({ type: events.FAILURE, payload: error?.response?.data });
    }
  }
}

function* watchAddACHPayment() {
  const events = actions.createRequestTypes(actions.ADD_ACH_PAYMENT_ACTION);
  while (true) {
    const { accountNumber, routingNumber, accountHolderName } = yield take(
      actions.ADD_ACH_PAYMENT_ACTION,
    );
    const stripe = yield call(loadStripe, process.env.REACT_APP_STRIPE_KEY);

    const params = {
      country: 'US',
      currency: 'usd',
      routing_number: routingNumber,
      account_number: accountNumber,
      account_holder_name: accountHolderName,
      account_holder_type: 'individual',
    };
    const body = yield call(stripe.createToken, 'bank_account', params);
    yield put({ type: events.REQUEST });
    try {
      yield* callAndDispatch(apiMethodsConst.ADD_PAYMENT_REQUEST, body.token);

      window.analytics.track('Add payment method', { type: 'ach' });

      history.push('/dashboard/payment');

      yield put({ type: events.SUCCESS });
    } catch (error) {
      yield put({ type: events.FAILURE, payload: error?.response?.data });
    }
  }
}

function* watchGetPlaidToken() {
  const events = actions.createRequestTypes(actions.GET_PLAID_TOKEN);
  while (true) {
    yield take(actions.GET_PLAID_TOKEN);

    yield put({ type: events.REQUEST });
    try {
      yield* callAndDispatch(apiMethodsConst.GET_PLAID_TOKEN);
      yield put({ type: events.SUCCESS });
    } catch (error) {
      yield put({ type: events.FAILURE, payload: error?.response?.data });
    }
  }
}

function* watchSubmitPlaidToken() {
  const events = actions.createRequestTypes(actions.SUBMIT_PLAID_TOKEN);
  while (true) {
    const { publicToken, metadata } = yield take(actions.SUBMIT_PLAID_TOKEN);

    yield put({ type: events.REQUEST });

    try {
      const response = yield* callAndDispatch(apiMethodsConst.SUBMIT_PLAID_TOKEN, {
        publicToken,
        metadata,
      });
      history.push('/dashboard/payment');
      if (shouldUsePaymentService()) {
        yield* callAndDispatch(apiMethodsConst.GET_ALL_PAYMENTS_REQUEST);
      }
      yield put({ type: events.SUCCESS, payload: response.data });
    } catch (error) {
      yield put({ type: events.FAILURE, payload: error?.response?.data });
    }
  }
}

function* watchAddCardPayment() {
  const events = actions.createRequestTypes(actions.ADD_PAYMENT_ACTION);
  while (true) {
    const { card } = yield take(actions.ADD_PAYMENT_ACTION);
    yield put({ type: events.REQUEST });
    try {
      yield* callAndDispatch(apiMethodsConst.ADD_PAYMENT_REQUEST, card.token);
      yield put({ type: events.SUCCESS });

      window.analytics.track('Add payment method', { type: 'card' });

      history.push('/dashboard/payment');
    } catch (error) {
      yield put({ type: events.FAILURE, payload: error?.response?.data });
    }
  }
}

function* watchDeletePayment() {
  const events = actions.createRequestTypes(actions.DELETE_PAYMENT_ACTION);
  while (true) {
    const { paymentId } = yield take(actions.DELETE_PAYMENT_ACTION);
    yield put({ type: events.REQUEST });
    try {
      yield* callAndDispatchPayload(apiMethodsConst.DELETE_PAYMENT_REQUEST, paymentId);
      yield put({ type: events.SUCCESS });
    } catch (error) {
      yield put({ type: events.FAILURE, payload: error?.response?.data });
    }
  }
}

function* watchSelectPayment() {
  const events = actions.createRequestTypes(actions.SELECT_PAYMENT_ACTION);
  while (true) {
    const { paymentId } = yield take(actions.SELECT_PAYMENT_ACTION);

    yield put({ type: events.REQUEST });
    try {
      if (shouldUsePaymentService()) {
        yield* callAndDispatchPayload(apiMethodsConst.SELECT_PAYMENT_REQUEST, paymentId);
      } else  {
        yield* callAndDispatch(apiMethodsConst.SELECT_PAYMENT_REQUEST, paymentId);
      }

      yield put({ type: events.SUCCESS });
    } catch (error) {
      yield put({ type: events.FAILURE, payload: error?.response?.data });
    }
  }
}

function* watchVerifyPayment() {
  const events = actions.createRequestTypes(actions.VERIFY_BANK_ACTION);
  while (true) {
    const { paymentId, data } = yield take(actions.VERIFY_BANK_ACTION);
    yield put({ type: events.REQUEST });
    try {
      yield* callAndDispatchPayload(apiMethodsConst.VERIFY_BANK_REQUEST, { paymentId, data });

      yield put({ type: events.SUCCESS });
    } catch (error) {
      yield put({ type: events.FAILURE, payload: error?.response?.data });
    }
  }
}

// use them in parallel
export default function* sagaPayments() {
  yield all([
    // paymnet
    fork(watchGetAllPaymnets),
    fork(watchDeletePayment),
    fork(watchAddACHPayment),
    fork(watchAddCardPayment),
    fork(watchSelectPayment),
    fork(watchVerifyPayment),
    fork(watchGetPlaidToken),
    fork(watchSubmitPlaidToken),
  ]);
}
